export enum ETaxSettingConfigs {
    OPT_IN = 'opt_in',
    OPT_OUT = 'opt_out'
}
